import VueHead from 'vue-head';
import Vue from 'vue';

Vue.use(VueHead);
